import React from 'react';
import Header from '../components/Header/Header';
import DeliveryHero from '../components/DeliveryHero/DeliveryHero';
import Footer from '../components/Footer/Footer';
import FooterCTA from '../components/FooterCTA/FooterCTA';
import DeliveryDetail from '../components/DeliveryDetail/DeliveryDetail';

const DeliveryPage = () => {
  return (
    <>
      <Header />
      <main>
        <DeliveryHero />
        <DeliveryDetail />
        {/* You can add more detailed sections about each delivery mode here */}
        <FooterCTA />
      </main>
      <Footer />
    </>
  );
};

export default DeliveryPage;